import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class GroupCategory {
    @JsonProperty("id")
    id: number;

    @JsonProperty("name")
    name: string;

    @JsonProperty("label")
    label: string;

    @JsonProperty("is_row_category")
    isRowCategory: boolean;
}
